import React, { useMemo } from "react";

import { IActiveLearningIssue } from "../../../../../../state";
import TextInput from "../../../../../../atoms/ActiveLearning/TextInput";
import TextArea from "../../../../../../atoms/ActiveLearning/TextArea";
import styles from "../../../ActiveLearningIssue.module.scss";

type Issue3MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue3Material = (props: Issue3MaterialProps) => {
  const question1 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);

  const question2 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 2);
  }, [props.issue?.questions]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          「問い」に答えを出す過程で、誰かの「もっとこうだったらいのに」や「こうしたい」を実現することができる。
          <br />
          自分が価値を届けたいと思う人［ターゲット］を決め、入力しよう。
        </p>
      </div>
      {question1 && <TextInput />}
      {question2 && (
        <div className={styles.themEntry}>
          <p className={styles.title}>{question2.title}</p>
          <p className={styles.read}>
            「問い」の内容を実現することで喜ぶ人はたくさんいる中で、なぜその人を喜ばせたいと思ったのかを入力しよう。
          </p>
          <div className={styles.textAreaWrapper}>
            <TextArea />
          </div>
        </div>
      )}
    </div>
  );
};
export default Issue3Material;
